export enum GAEnums {
  production = 'G-KP90BTNPCN',
  development = 'G-FE0X0DW2RJ'
}

const createScript = (): HTMLScriptElement => document.createElement('script');

export const addGAScripts = (trackingCode: GAEnums = GAEnums.development): Promise<void> => {
  const head = document.head;
  const lib = createScript();
  const gtag = createScript();

  lib.src = `https://www.googletagmanager.com/gtag/js?id=${trackingCode}`;
  lib.async = true;

  gtag.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${trackingCode}');
  `;
  head.prepend(lib);
  return new Promise<void>(resolve => {
    lib.onload = () => {
      lib.after(gtag);
      resolve();
    };
  });
};
